import { WixSDK } from '../polyfills/wix-sdk';
export const ImageService = {
    getResizedImageSize: (currentWidth, currentHeight, maxWidth, maxHeight) => {
        const ratio = Math.min(Math.max(maxWidth / currentWidth, maxHeight / currentHeight) * 2, 1);
        return {
            width: currentWidth * ratio,
            height: currentHeight * ratio,
        };
    },
    getImageStyle: (url, width, height, position, opacity, size = 'cover') => ({
        backgroundImage: `url(${WixSDK.Utils.Media.getResizedImageUrl(url, width, height)})`,
        backgroundPosition: resolveImagePosition(position),
        backgroundRepeat: 'no-repeat',
        backgroundSize: size,
        opacity: opacity / 100,
    }),
};
const resolveImagePosition = (position) => {
    let horizontal = 'center', vertical = '';
    if (position % 3 === 0) {
        horizontal = 'right';
    }
    else if ((position - 1) % 3 === 0) {
        horizontal = 'left';
    }
    if (position < 4) {
        vertical = 'top';
    }
    else if (position < 7) {
        vertical = 'center';
    }
    else {
        vertical = 'bottom';
    }
    return `${horizontal} ${vertical}`;
};
//# sourceMappingURL=image.js.map